/* eslint-disable no-console */
import axios from 'axios';
import { userStore } from 'stores';
import { secureLs } from 'utils';

const axiosInstance = axios.create({
	headers: {
		'Content-Type': 'application/json'
	},
	baseURL: process.env.REACT_APP_API_URL
});

//auth
const $auth = axios.create({
	...axiosInstance.defaults,
	method: 'POST'
});

//api
const $api = axios.create({ ...axiosInstance.defaults });
const authInterceptor = (config: any) => {
	config.headers.authorization = `Bearer ${secureLs.get('token')}`;
	return config;
};

$api.interceptors.request.use((config: any) => {
	authInterceptor(config);
	config._startTime = Date.now();
	console.log(`[API →] ${config.method?.toUpperCase()} ${config.url}`);
	return config;
});

$api.interceptors.response.use(
	(response: any) => {
		const ms = Date.now() - (response.config._startTime ?? Date.now());
		console.log(`[API ✓] ${response.config.method?.toUpperCase()} ${response.config.url} → ${response.status} (${ms}ms)`);
		return response;
	},
	(error: any) => {
		const ms = Date.now() - (error.config?._startTime ?? Date.now());
		const status = error.response?.status ?? 'no response';
		const data = error.response?.data;
		console.error(`[API ✗] ${error.config?.method?.toUpperCase()} ${error.config?.url} → ${status} (${ms}ms)`, data);
		if (data?.code === 'jwt_auth_invalid_token') {
			userStore.logout();
			window.location.href = '/login';
		}
		return Promise.reject(error);
	}
);

export {
	$api,
	$auth
};
